import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ProductoService {

  backendUrl: string = environment.apiUrl;
  url_final: string;


  constructor(private http: HttpClient) {
  }

  consultarProducto(item_id){
    this.url_final = this.backendUrl + "/rmsfe/producto?item_id="
    this.url_final = `${this.url_final}${item_id}`;
    return this.http.get<any>(this.url_final,  {observe: 'response'})
    .pipe(map(response => {
      // console.log("la api es");
      // console.log(response)
      return response;
    }));
  }

  crearProducto(title, seller_sku, ean, ml_sku, pdf_ml_sku, amz_sku, pdf_amz_sku, length, width, height, weight, list_price, acepta_bo, clave_sat, fraccion_arancelaria, etiqueta_nom, safety_stock){
    this.url_final = this.backendUrl + "/rmsfe/crear_producto_api"
    this.url_final = `${this.url_final}`;

    var fd = new FormData();

    if (pdf_ml_sku != undefined){
      fd.append('pdf_ml_sku', pdf_ml_sku, pdf_ml_sku.name);
    }

    if (pdf_amz_sku != undefined){
      fd.append('pdf_amz_sku', pdf_amz_sku, pdf_amz_sku.name);
    }

    if (etiqueta_nom != undefined){
      fd.append('etiqueta_nom', etiqueta_nom, etiqueta_nom.name);
    }

    fd.append('title', title);
    fd.append('seller_sku', seller_sku);
    fd.append('ean', ean);
    fd.append('ml_sku', ml_sku);
    fd.append('amz_sku', amz_sku);
    fd.append('length', length);
    fd.append('width', width);
    fd.append('height', height);
    fd.append('weight', weight);
    fd.append('list_price', list_price);
    fd.append('acepta_bo', acepta_bo);
    fd.append('clave_sat', clave_sat);
    fd.append('fraccion_arancelaria', fraccion_arancelaria);
    fd.append('clave_sat', clave_sat);
    fd.append('safety_stock', safety_stock);

    return this.http.post<any>(this.url_final, fd)
    .pipe(map(response => {
      return response;
    }));
  }

  actualizarProducto(item_id, title, seller_sku, ean, ml_sku, pdf_ml_sku, amz_sku, pdf_amz_sku, length, width, height, weight, list_price, acepta_bo, clave_sat, fraccion_arancelaria, etiqueta_nom, safety_stock){
    this.url_final = this.backendUrl + "/rmsfe/actualizar_producto_api"
    this.url_final = `${this.url_final}`;

    var fd = new FormData();

    if (pdf_ml_sku != undefined){
      fd.append('pdf_ml_sku', pdf_ml_sku, pdf_ml_sku.name);
    }

    if (pdf_amz_sku != undefined){
      fd.append('pdf_amz_sku', pdf_amz_sku, pdf_amz_sku.name);
    }

    if (etiqueta_nom != undefined){
      fd.append('etiqueta_nom', etiqueta_nom, etiqueta_nom.name);
    }

    fd.append('item_id', item_id);
    fd.append('title', title);
    fd.append('seller_sku', seller_sku);
    fd.append('ean', ean);
    fd.append('ml_sku', ml_sku);
    fd.append('amz_sku', amz_sku);
    fd.append('length', length);
    fd.append('width', width);
    fd.append('height', height);
    fd.append('weight', weight);
    fd.append('list_price', list_price);
    fd.append('acepta_bo', acepta_bo);
    fd.append('clave_sat', clave_sat);
    fd.append('fraccion_arancelaria', fraccion_arancelaria);
    fd.append('clave_sat', clave_sat);
    fd.append('safety_stock', safety_stock);

    return this.http.post<any>(this.url_final, fd)
    .pipe(map(response => {
      return response;
    }));
  }

  eliminarPorducto(item_id){
    this.url_final = this.backendUrl + "/rmsfe/eliminar_producto_api"
    this.url_final = `${this.url_final}`;

    var fd = new FormData();
    fd.append('item_id', item_id);

    return this.http.post<any>(this.url_final, fd)
    .pipe(map(response => {
      return response;
    }));

  }

  consultarPlantilla(){
    this.url_final = this.backendUrl + "/rmsfe/consultar_plantilla_items"
    this.url_final = `${this.url_final}`;
    return this.http.get<any>(this.url_final, { observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  mandarEntrada(file_name){
    this.url_final = this.backendUrl + "/rmsfe/entrada_masiva_items"
    this.url_final = `${this.url_final}`;
    return this.http.post<any>(this.url_final, { file_name })
    .pipe(map(response => {
      return response;
    }));
  }

  consultarMasivo(){
    this.url_final = this.backendUrl + "/rmsfe/consultar_masivo_items"
    this.url_final = `${this.url_final}`;
    return this.http.get<any>(this.url_final, { observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  consultarBoxes(){
    this.url_final = this.backendUrl + "/rmsfe/consultar_boxes_fulfillment_api"
    this.url_final = `${this.url_final}`;
    return this.http.get<any>(this.url_final, { observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  consultarPublicaciones(item_id){
    this.url_final = this.backendUrl + "/rmsfe/publicaciones_item?item_id="
    this.url_final = `${this.url_final}${item_id}`;
    return this.http.get<any>(this.url_final,  {observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  /* -------------------EDICIÓN MASIVA---------------------------- */
  generarPlantilla(productos_pausados, productos_en_ceros){
    this.url_final = this.backendUrl + "/rmsfe/generar_formato_edicion_masiva_api"
    this.url_final = `${this.url_final}`;
    return this.http.post<any>(this.url_final, { productos_pausados:  productos_pausados, productos_en_ceros: productos_en_ceros, observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  consultarInformeGenerarPlantilla(){
    this.url_final = this.backendUrl + "/rmsfe/status_informe_formato_edicion_masiva_api"
    this.url_final = `${this.url_final}`;
    return this.http.get<any>(this.url_final, { observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  mandarEdicionMasiva(file_name){
    this.url_final = this.backendUrl + "/rmsfe/cargar_formato_edicion_masiva_api"
    this.url_final = `${this.url_final}`;
    return this.http.post<any>(this.url_final, { file_name })
    .pipe(map(response => {
      return response;
    }));
  }

  consultarEdicionMasivo(){
    this.url_final = this.backendUrl + "/rmsfe/status_informe_edicion_masiva_api"
    this.url_final = `${this.url_final}`;
    return this.http.get<any>(this.url_final, { observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }
}
